export default __webpack_public_path__ + "static/media/people3small.fd418e8a.jpg";